var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CardExamsInformation_1;
import React from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { PureComponent } from 'react';
import CardExamsInformationAPI from './card-exams-information-api';
import { Card, Image } from '@philips-internal/oswald-ui-components/lib/components';
import { generateUUID, trigger } from '@philips-internal/oswald-ui-utils';
import { eventListener, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/message-service';
import { ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import timeIcon from '../../assets/images/global/hpms-time.svg';
import checkGrayIcon from '../../assets/images/global/check-blue.svg';
import checkIcon from '../../assets/images/global/check-green.svg';
import './card-exams-information.css';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
let CardExamsInformation = class CardExamsInformation extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            data: {},
            visible: true,
            width: 12
        };
    }
    static { CardExamsInformation_1 = this; }
    static { this.propTypes = {
        dtProcedimento: string,
        onClick: eventListener,
        status: string
    }; }
    static { this.STATUS_MAP = new Map([
        ['A', { expression: 'patient.available', icon: checkIcon }],
        ['I', { expression: 'patient.status.partially-available', icon: timeIcon }],
        ['P', { expression: 'patient.processing', icon: timeIcon }],
        ['R', { expression: 'patient.ready', icon: checkGrayIcon }],
    ]); }
    render() {
        const { onClick, dtProcedimento, status } = this.props;
        const weekDay = dtProcedimento ? ModelService.format('date', dtProcedimento) : '';
        const statusIconInfo = CardExamsInformation_1.STATUS_MAP.get(status);
        const examIcon = statusIconInfo ? statusIconInfo.icon : '';
        const examExpression = statusIconInfo ? MessageService.translate(statusIconInfo.expression) : '';
        return (React.createElement(Card, { uuid: generateUUID(), className: 'card-exam-information', onClick: trigger(onClick, new ClickEvent()), width: 12, selectionType: SelectionType.NONE },
            React.createElement("div", { className: 'date-info' },
                React.createElement("div", { className: 'info-label' }, MessageService.translate('patient.date')),
                React.createElement("div", { className: 'day-week' }, weekDay)),
            React.createElement("div", { className: 'status-info' },
                React.createElement("div", { className: 'info-label' }, MessageService.translate('patient.exam-status')),
                React.createElement("div", { className: 'status' },
                    React.createElement(Image, { src: examIcon, className: 'status-icon', alt: '' }),
                    examExpression))));
    }
};
CardExamsInformation = CardExamsInformation_1 = __decorate([
    AwesomeComponent({ api: CardExamsInformationAPI, type: ComponentType.DATA_DISPLAY })
], CardExamsInformation);
export default CardExamsInformation;
//# sourceMappingURL=card-exams-information.js.map